import React, { useState, useEffect } from "react";
import API from "../api";
import { useAuth } from "../context/AuthContext";
import { Table } from "react-bootstrap";

function formatThruDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "numeric", day: "numeric" });
}

export default function StandingsPage() {
  const { user } = useAuth();
  const [standings, setStandings] = useState([]);
  const [thruDate, setThruDate] = useState(null);
  const [contestWinners, setContestWinners] = useState([]);
  const [winnerWeekNumber, setWinnerWeekNumber] = useState(null);

  useEffect(() => {
    if (user?.leagueid) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    try {
      const standingsRes = await API.get(`/points/standings/${user.leagueid}`);
      const data = standingsRes.data;
      setStandings(Array.isArray(data) ? data : (data.standings || []));

      if (data && typeof data === "object" && !Array.isArray(data) && data.thru_date !== undefined) {
        setThruDate(data.thru_date);
      } else {
        const weeksRes = await API.get(`/league/${user.leagueid}/weeks`);
        const todayIso = new Date().toISOString().slice(0, 10);
        const past = (weeksRes.data || [])
          .map(w => w.date)
          .filter(d => d && d < todayIso)
          .sort();
        setThruDate(past.length ? past[past.length - 1] : null);
      }

      const winnersRes = await API.get(`/scorecard/contest-winners/${user.leagueid}/latest`);
      setContestWinners(winnersRes.data);
      if (winnersRes.data.length > 0) {
        setWinnerWeekNumber(winnersRes.data[0].week_number);
      }
    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  const calculatePlaces = (data) => {
    let sorted = [...data].sort((a, b) => b.total_points - a.total_points);
    let result = [];
    let actualPlace = 1;

    for (let i = 0; i < sorted.length; ) {
      let group = sorted.filter(r => r.total_points === sorted[i].total_points);
      if (group.length > 1) {
        group.forEach(g => (g.place = `T${actualPlace}`));
      } else {
        group[0].place = `${actualPlace}`;
      }
      result = [...result, ...group];
      i += group.length;
      actualPlace += group.length;
    }

    return result;
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const styles = `
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
        table { width: 100%; border-collapse: collapse; margin: auto; }
        th, td { border: 1px solid #000; padding: 5px; text-align: center; }
        h3, h5 { margin-top: 0; }
        .winner-line { margin: 4px 0; }
      </style>
    `;

    const tableHtml = document.getElementById("printable-standings").innerHTML;
    printWindow.document.write(`<html><head><title>Standings</title>${styles}</head><body>${tableHtml}</body></html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div className="container mt-4">
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <button
          id="print-button"
          className="btn btn-secondary"
          onClick={handlePrint}
        >
          🖨️ Print Standings
        </button>
      </div>

      <div id="printable-standings">
        <h3 style={{ textAlign: "center" }}>
          {[user?.league?.day, user?.league?.name].filter(Boolean).join(" ")} League Standings{thruDate ? ` thru ${formatThruDate(thruDate)}` : ""}
        </h3>
        <Table bordered striped>
          <thead>
            <tr>
              <th>Place</th>
              <th>Team ID</th>
              <th>Player 1</th>
              <th>Avg</th>
              <th>Hdcp</th>
              <th>Player 2</th>
              <th>Avg</th>
              <th>Hdcp</th>
              <th>Total Points</th>
            </tr>
          </thead>
          <tbody>
            {calculatePlaces(standings).map((team) => (
              <tr key={team.team_id}>
                <td>{team.place}</td>
                <td>{team.team_id}</td>
                <td>{team.player1_name}</td>
                <td>{team.player1_avg}</td>
                <td>{team.player1_hdcp}</td>
                <td>{team.player2_name}</td>
                <td>{team.player2_avg}</td>
                <td>{team.player2_hdcp}</td>
                <td>{team.total_points}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {contestWinners.length > 0 && (
          <div className="mt-4" style={{ textAlign: "center" }}>
            <h5><strong>Contest Winners</strong></h5>
            {contestWinners.map((winner, index) => {
              const [name, hole] = winner.challenge.split(":").map(s => s.trim());
              return (
                <div key={index} className="winner-line">
                  {name} on {hole}: {winner.player_name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

